import { render, staticRenderFns } from "./AddNote.vue?vue&type=template&id=47e3ec30&scoped=true&"
import script from "./AddNote.vue?vue&type=script&setup=true&lang=js&"
export * from "./AddNote.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47e3ec30",
  null
  
)

export default component.exports